import { ContratarProduto } from "../../components/ComponentZapMei/Contratar";
import { Footer } from "../../components/ComponentZapMei/Footer";

function ContratarZapMei() {


  return (
    <>
        <ContratarProduto />
          <div style={{background: "#091a27", width: "100%"}}>
                        
        <Footer />
                    </div>
    </>
  );
}
export default ContratarZapMei;
